import React, { useEffect, useState } from 'react'
import startChat from '../../../assets/img/start-chat.svg'
import Logostar from '../../../assets/img/logox.svg'
import useSignalR from '../useSignalR'
import { enumUtil } from '../../../utils/Enum'
import { ServerRequestProtected } from '../../../utils/ServerDataRequest'
import NotificationHandler from '../../../utils/NotificationHandler'
import UsersWithPastChat from './UsersWithPastChat'
import Loader from '../../shared/Loader/Loader'
import UserSearch from './UserSearch'
const StartChatnew = ({ closeChat, conn }) => {
    const API_URL = process.env.REACT_APP_API
    const API_URL_General = enumUtil.controller.General
    const API_URL_Messages = enumUtil.controller.Messages
    const [connection, setConnection] = useState(null);
    const [senderUserID, setSenderUserID] = useState(0)
    const [senderUserName, setSenderUserName] = useState('')
    const [PracticeID, setPracticeID] = useState(0)
    const [users, setUsers] = useState([]);
    const [tempUser, setTempUser] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [mainActivetab, setmainActivetab] = useState('')
    const [userimages, setUserImages] = useState([]);

    const GetUserImages = (imageList) => {
        ServerRequestProtected(API_URL_Messages + "/GetImages", 'post', {
            // ListofData: imageList,
            Data: {
                ForImages: "true"
            }
        }).then((response) => {
            // setIsLoading(false)
            setUserImages(response.Images)
        }).catch((error) => {
            // setIsLoading(false)
        })
    }
    useEffect(() => {
        ServerRequestProtected(API_URL_General + "/FindUserInfo", 'post', {
            "TableName": enumUtil.enumAPITableName.USERPRACTICES
        }).then((response) => {
            setSenderUserID(response.UserID + "")
            setSenderUserName(response.UserName)
            setPracticeID(response.PracticeID)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
        setIsLoading(true)
        ServerRequestProtected(API_URL_Messages + "/FetchPastInterlocutors", 'post', {
        }).then((response) => {
            const imageList = response.map((item) => {
                return {
                    UserID: item.ReceiverID + "",
                    BucketPath: item.ProfilePictureURL
                }
            })
            // GetUserImages(imageList, response)
            if (response.length > 0) {
                setmainActivetab('ChatList')
            }
            setIsLoading(false)
            setUsers(response)
            setTempUser(response)
        }).catch((error) => {
            setmainActivetab('NewChat')
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
        GetUserImages()
    }, [])
    useEffect(() => {
        setConnection(conn);
    }, [conn]);
    const [isOpenFromNewChat, setIsOpenFromNewChat] = useState(false)
    const [newUserInfo, setnewUserInfo] = useState({})
    const handleUserSearch = () => {
        setIsOpenFromNewChat(false)
        setmainActivetab('UserSearch')
    }
    const handleSelectUser = (item) => {
        setIsOpenFromNewChat(true)
        setnewUserInfo(item)
        setmainActivetab('ChatList')
    }
    const [forawardedMessage, setForwardedMessage] = useState(null)
    const ForwardedMesg = (item) => {
        setForwardedMessage(item)
        setmainActivetab('UserSearch')
    }
    const ClearForwardMesg = () => {
        setForwardedMessage(null)
    }
    return (
        <>
            {/* <div className='ar-sart-chat-screen'>
                {isLoading ? <Loader /> : null}
                <div className='d-flex justify-content-between align-items-center pe-2 pb-1 br-bottom-1 br-clr mb-10'>
                    <div className='d-flex gap-1 align-items-center'>
                        <div className="img-container s-40 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <p className='heading fs-14'>Messaging</p>
                    </div>
                    <i className='icon-Icon-metro-cross fs-13' onClick={closeChat}></i>
                </div>
                <div className='px-1'>
                    <div className="input">
                        <input
                            type="text"
                            className="form-control rounded"
                            name="FirstName"
                            id="FirstName"
                        />
                    </div>
                </div>

                {users && users.length > 0 ?
                    <UsersWithPastChat
                        users={users}
                        connection={connection}
                        senderUserID={senderUserID}
                        senderUserName={senderUserName}
                        PracticeID={PracticeID}
                        mainActivetab={mainActivetab}
                        setmainActivetab={setmainActivetab}
                    /> :
                    <div className='d-flex flex-column align-items-center justify-content-center ar-content'>
                        <img src={startChat} />
                        <p className='text fs-13 ar-light-color text-center'>Once you start a new conversation, you’ll
                            see it listed here  </p>
                    </div>
                }
                <div className='text-end'>
                    <button className='btn btn-green px-10'><i className='bi bi-chat-dots-fill text-white fs-13'></i> Start Chat</button>
                </div>



            </div> */}
            {/* 
                Component                       TabID
                    ChatList            =>          ChatList 
                    NewChat             =>          NewChat
                    UserSearch          =>          UserSearch
                    ChatWindow          =>          ChatWindow
                    UserInfo            =>          UserInfo
            */}

            {/*  
                 1) if user chat with past chat availabe then show (ChatList)                                                                None
                        else show New chat screen (NewChat)                                                                                  None
                            i) if user click on  (NewChat) naviagte to (UserSearch) where user can serach others and initate chat            previuos screen will be (NewChat) 
                            ii) on click of the searched users, user will navigate to (ChatWindow)                                           previuos screen will be (NewChat)     
                    on click on the user, user will navigate to (ChatWindow)                                                                 previuos screen will be (ChatList)                                                  

                2) from both cases user will be on (ChatWindow)
                    in (ChatWindow) screen when user click on other user image user will navigate to (UserInfo)                             previuos screen will be (ChatWindow)

            */}
            {isLoading ? <Loader /> : null}
            {
                mainActivetab === 'NewChat' ?
                    <div className='ar-sart-chat-screen'>
                        <div className='d-flex justify-content-between align-items-center pe-2 pb-1 br-bottom-1 br-clr mb-10'>
                            <div className='d-flex gap-1 align-items-center'>
                                <div className="img-container s-40 circle">
                                    <img src={Logostar} alt="" className='object-fit-contain' />
                                </div>
                                <p className='heading fs-14'>STAR CHAT BOT</p>
                            </div>
                            <i className='icon-x-cros dark-clr fs-24' onClick={closeChat}></i>
                        </div>
                        <div className='d-flex flex-column align-items-center justify-content-center ar-content'>
                            <img src={startChat} />
                            <p className='text fs-13 ar-light-color text-center'>Once you start a new conversation, you’ll
                                see it listed here  </p>
                        </div>
                        <div className='text-end'>
                            <button className='btn btn-green px-10' onClick={handleUserSearch}><i className='bi bi-chat-dots-fill text-white fs-13'></i> Start Chat</button>
                        </div>
                    </div> : mainActivetab === 'ChatList' || mainActivetab === 'userChat' ?
                        <div className='ar-sart-chat-screen'>
                            <div className='d-flex justify-content-between align-items-center pb-1 br-bottom-1 br-clr mb-1 mesages-header'>
                                <div className='d-flex gap-1 align-items-center'>
                                    <div className="img-container s-40 circle">
                                        <img src={Logostar} alt="" className='object-fit-contain' />
                                    </div>
                                    <p className='heading fs-14'>STAR CHAT</p>
                                </div>
                                <i className='icon-x-cros dark-clr fs-24' onClick={closeChat}></i>
                            </div>
                            <UsersWithPastChat
                                users={users}
                                connection={connection}
                                senderUserID={senderUserID}
                                senderUserName={senderUserName}
                                PracticeID={PracticeID}
                                // mainActivetab={mainActivetab}
                                ForwardedMesg={ForwardedMesg}
                                isOpenFromNewChat={isOpenFromNewChat}
                                newUserInfo={newUserInfo}
                                setUsers={setUsers}
                                userimages={userimages}
                                forawardedMessage={forawardedMessage}
                                ClearForwardMesg={ClearForwardMesg}
                            />
                            {mainActivetab === 'userChat' ? null :
                                <div className='text-end start-chat-btn'>
                                    <button className='btn btn-green px-10 py-1-5 h-100' onClick={handleUserSearch}><i className='bi bi-chat-dots-fill text-white fs-13'></i> <span>Start Chat</span></button>
                                </div>}
                        </div> : mainActivetab === 'UserSearch' ?
                            <UserSearch
                                users={users}
                                userimages={userimages}
                                setmainActivetab={setmainActivetab}
                                handleSelectUser={handleSelectUser}
                            />
                            : null
            }
        </>
    )
}

export default StartChatnew